import Text from "~/ui/typography"

interface StripeConnectPendingBannerProps {
  hasStripeAccount: boolean
  stripeConnectReady: boolean
  stripeConnectRequirementsPending: boolean
}

export const StripeConnectPendingBanner: React.FC<StripeConnectPendingBannerProps> = ({
  hasStripeAccount,
  stripeConnectReady,
  stripeConnectRequirementsPending,
}) => {
  if (!hasStripeAccount || stripeConnectReady) return null

  return (
    <div className="rounded-lg border border-gray-800 bg-gray-900/40 p-4">
      <Text as="div" className="text-sm font-semibold text-gray-200">
        Stripe connection pending
      </Text>
      <Text as="div" className="mt-2 text-sm text-gray-400">
        {stripeConnectRequirementsPending
          ? "Your payout account is not fully verified yet. Please finish the Stripe onboarding steps or wait for Stripe to complete verification. Once approved, you’ll be able to set a price and accept subscriptions."
          : "We’ve created your Stripe account, but onboarding isn’t complete yet. Continue the Stripe setup to finish verification and unlock pricing."}
      </Text>
    </div>
  )
}
